var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 5V5C9.22524 5 7.40037 5 6.24184 6.10301C6.19443 6.14814 6.14814 6.19443 6.10301 6.24184C5 7.40037 5 9.22524 5 12.875V17C5 17.9428 5 18.4142 5.29289 18.7071C5.58579 19 6.05719 19 7 19H11.125C14.7748 19 16.5996 19 17.7582 17.897C17.8056 17.8519 17.8519 17.8056 17.897 17.7582C19 16.5996 19 14.7748 19 11.125V11.125",
    stroke: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10L15 10",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H12",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8L19 2M16 5H22",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPlusIcon);
export default __webpack_public_path__ + "static/media/chatPlusIcon.327878c007b70f1cfd2bb9d900e38fde.svg";
export { ForwardRef as ReactComponent };